import React, { createContext, useContext, useState, useEffect } from 'react';

// Language Context
const LanguageContext = createContext();

// Custom hook to use the language context
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

// Language Provider Component
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('es');

  // Read language from URL on mount and when URL changes
  useEffect(() => {
    const checkUrlLanguage = () => {
      // Parse URL params from the full URL to ensure we get all parameters
      const url = new URL(window.location.href);
      const langParam = url.searchParams.get('lang');
      
      if (langParam && ['es', 'en', 'pt'].includes(langParam)) {
        setLanguage(langParam);
      } else {
        // Default to Spanish if no valid language parameter
        setLanguage('es');
      }
    };

    // Check initial URL
    checkUrlLanguage();

    // Listen for URL changes
    window.addEventListener('popstate', checkUrlLanguage);
    
    // Also listen for hash changes and other navigation events
    const handleUrlChange = () => {
      setTimeout(checkUrlLanguage, 0);
    };
    
    window.addEventListener('hashchange', handleUrlChange);
    window.addEventListener('pushstate', handleUrlChange);
    window.addEventListener('replacestate', handleUrlChange);
    
    return () => {
      window.removeEventListener('popstate', checkUrlLanguage);
      window.removeEventListener('hashchange', handleUrlChange);
      window.removeEventListener('pushstate', handleUrlChange);
      window.removeEventListener('replacestate', handleUrlChange);
    };
  }, []);

  const value = {
    language,
    setLanguage
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;